<template>
  <div class="space-y-3">
    <div class="flex items-center gap-2">
      <button
        type="button"
        class="flex shrink-0 items-center space-x-2 rounded-full active:shadow-md"
        @click="bottomSheet.show(medicalInsuranceConfig.SUM_BOTTOM_SHEET)"
      >
        <span class="text-text-neutral-tertiary text-xs font-medium">
          {{ t('ancillaries.medicalInsurance.insuranceSum.title') }}
        </span>
        <InfoIcon class="h-5 w-5" />
      </button>
    </div>
    <div class="flex space-x-2">
      <button
        v-for="amountId in Object.keys(amounts)"
        :key="amountId"
        :disabled="isLoading"
        :class="[
          'rounded-xl border px-4 py-2 text-sm font-semibold transition',
          selectedAmountId === amountId
            ? 'bg-background-positive-primary text-static-white border-background-positive-primary'
            : 'text-text-neutral-tertiary bg-background-neutral-secondary border-button-secondary-default',
        ]"
        type="button"
        @click="onAmountSelect(amountId)"
      >
        {{ getPrettyAmount(amounts[amountId]) }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { prettyPrice } from '@aviata/text-fns';
  import { controllerModel } from 'shared';

  import InfoIcon from '@/assets/images/product-details-icon.svg?component';

  import { medicalInsuranceConfig } from '../config';

  const props = defineProps<{
    amounts: Record<string, string>;
    initialAmountId: string;
    offerId: string;
    productIds: string[];
    isLoading: boolean;
  }>();

  const emit = defineEmits<{
    onResetPassengers: [];
    onAmountSelected: [string];
  }>();

  const selectedAmountId = ref(props.initialAmountId);
  const bottomSheet = controllerModel.useBottomSheet();

  watch(
    () => props.initialAmountId,
    newVal => {
      selectedAmountId.value = newVal;
    },
  );

  const { t } = useI18n();

  function onAmountSelect(amountId: string) {
    selectedAmountId.value = amountId;
    emit('onAmountSelected', amountId);
  }

  function getPrettyAmount(amount: string) {
    const currency = amount[amount.length - 1];
    return `${prettyPrice(amount)} ${currency}`;
  }
</script>
